import React, { useMemo } from "react";
import { i18nService } from "services";
import { IAPIState } from "types";

interface SearchMessageProps {
  total?: number;
  status: IAPIState;
  hasSearched?: boolean;
}

export const SearchMessage: React.FC<SearchMessageProps> = ({
  total,
  status,
  hasSearched,
}) => {
  const message = useMemo(() => {
    if (status === IAPIState.pending) {
      return i18nService.copy["siteSearch.loading"];
    }

    if (hasSearched && total === 0) {
      return i18nService.copy["siteSearch.noResults"];
    }

    if (hasSearched && total && total > 0) {
      return `${total} ${i18nService.copy["siteSearch.results"]}`;
    }
  }, [status, hasSearched, total]);

  return <div className="search-message">{message}</div>;
};
